import FreeItemSection from './freeItemSection'

export default FreeItemSection



// WEBPACK FOOTER //
// ./client/pages/home/freeItemSection/index.tsx